import gsap from 'gsap';
import { onMounted, onUnmounted, ref } from 'vue';

import { ANIMATION_CONFIGS } from '~/constants/animations';

export function useQuickView(_opts = {}) {
  const opts = {
    closeOnClickOutside: false,
    closeOnEscapeKey: false,
    id: null,
    isOpenByDefault: false,
    ..._opts,
  };
  const isOpen = ref(opts.isOpenByDefault);

  const handleToggleOpen = function (value) {
    isOpen.value = value ?? !isOpen.value;
    const target = document.querySelector(`[data-quick-view="${opts.id}"]`);
    if (isOpen.value) {
      gsap.fromTo(
        target,
        {
          opacity: 0,
          yPercent: 10,
        },
        {
          onStart() {
            target?.classList.remove('hidden');
          },
          ...ANIMATION_CONFIGS.QUICK_VIEW_FADE_IN_MOVE_UP,
        },
      );
    } else {
      gsap.fromTo(
        target,
        { opacity: 1, yPercent: 0 },
        {
          onComplete() {
            target?.classList.add('hidden');
          },
          ...ANIMATION_CONFIGS.QUICK_VIEW_FADE_OUT_MOVE_DOWN,
        },
      );
    }
  };

  const handleClickOutside = (event) => {
    const target = event.target;
    const isOpenButtonClicked = !!target.closest(`[data-button-open="${opts.id}"]`);
    const isQuickViewBoxClicked = !!target.closest(`[data-quick-view="${opts.id}"]`);
    if (isOpenButtonClicked || isQuickViewBoxClicked) return false;
    handleToggleOpen(false);
  };

  const handleKeyDownEscape = (event) => {
    if (event.key === 'Escape' && isOpen.value) {
      handleToggleOpen(false);
    }
  };

  onMounted(() => {
    // Initialize the quick view state (open or closed)
    const target = document.querySelector(`[data-quick-view="${opts.id}"]`);
    if (isOpen.value) {
      target?.classList.remove('hidden', 'opacity-0');
    } else {
      target?.classList.add('hidden', 'opacity-0');
    }

    // Add event listeners for closing the quick view on click outside or escape key
    if (opts.closeOnClickOutside && opts.id) {
      document.addEventListener('click', handleClickOutside);
    }

    // Add event listeners for closing the quick view on escape key
    if (opts.closeOnEscapeKey && opts.id) {
      document.addEventListener('keydown', handleKeyDownEscape);
    }
  });

  onUnmounted(() => {
    if (opts.closeOnClickOutside && opts.id) {
      document.removeEventListener('click', handleClickOutside);
    }
    if (opts.closeOnEscapeKey && opts.id) {
      document.removeEventListener('keydown', handleKeyDownEscape);
    }
  });

  return {
    handleToggleOpen,
    isOpen,
  };
}
